import { Box } from '@mui/material';
import { ChecklistFacilAsset } from 'app/checklist-facil/components/ChecklistFacilAsset';
import { ChecklistFacilCompany } from 'app/checklist-facil/components/ChecklistFacilCompany';
import { AUTHORITIES } from 'app/config/constants';
import Logout from 'app/modules/login/logout';
import PrivateRoute from 'app/shared/auth/private-route';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';

const Dashboards = Loadable({
  loader: () => import('app/modules/dashboards'),
  loading: () => <div>loading ...</div>,
});

export const CheckListRoutes = () => {
  return (
    <Box className="box-container" style={{ height: '100%' }}>
      <Switch>
        <PrivateRoute path="/dashboards" component={Dashboards} hasAnyAuthorities={[AUTHORITIES.CHECKLIST]} />

        <PrivateRoute path="/" component={EntitiesChecklistFacil} hasAnyAuthorities={[AUTHORITIES.CHECKLIST]} />
      </Switch>
    </Box>
  );
};

const EntitiesChecklistFacil = ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.url}checklistfacil/asset`} component={ChecklistFacilAsset} />
      <Route path="/" exact component={ChecklistFacilCompany} />
      <Redirect path="*" to="/" />
    </Switch>
  );
};
